import { useEffect, useRef, useState } from 'react';

export enum Direction {
  up = 'up',
  down = 'down',
}

const useScrollDirection = () => {
  const [direction, setDirection] = useState<Direction>(Direction.up);
  const oldScrollY = useRef(0);
  const ticking = useRef(false);

  const updateDirection = () => {
    const currentY = window.scrollY;
    const diff = currentY - oldScrollY.current;

    if (Math.abs(diff) > 10) {
      const newDirection = diff > 0 ? Direction.down : Direction.up;
      if (newDirection !== direction) {
        setDirection(newDirection);
      }
      oldScrollY.current = currentY;
    }

    ticking.current = false;
  };

  const onScroll = () => {
    if (!ticking.current) {
      window.requestAnimationFrame(updateDirection);
      ticking.current = true;
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [direction]);

  return direction;
};

export default useScrollDirection;
